import type { ReactNode } from "react";

/**
 * The page header: the title, and what this screen wants to say under it.
 *
 * It used to carry the person as well — role chips, name, avatar, language,
 * theme and sign-out — on all eleven screens, six controls arguing with the
 * title for the top of the page. They belong to the person, not to the
 * business, so they moved to the profile behind the sidebar row.
 *
 * `sub` is optional: a subtitle that only restates the title is noise, so a
 * screen whose name already says it leaves it out.
 */
export function PageTop({ title, sub }: { title: string; sub?: ReactNode }) {
  return (
    <header className="top">
      <div>
        <h1>{title}</h1>
        {sub ? <p className="sub">{sub}</p> : null}
      </div>
    </header>
  );
}
